import { useT } from '../../lib/i18n'

export default function Facts () {
  const t = useT()
  return (
    <section className="lp-facts">
      <div className="lp-wrap">
        <ul className="lp-facts__in">
          {t.facts.map(f => (
            <li key={f.t} className="lp-fact lp-rv">
              <b>{f.t}</b>
              <span>{f.s}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
